/* eslint-disable */
import config from '../../config'
import PageHeader from '../../components/pages/header'
import { useContext, useEffect, useState } from 'react'
import styles from './index.module.scss'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { VacancyCard } from '../../components/core/cards'
import './style.css'
import { PageContext } from '../../context/PageContextProvider'
import Loading from '../../components/pages/loading'
import CareersAPI from '../../api/careers'
import translate from '../../utils/translate.json'

const Careers = ({ className }) => {
  const { language } = useContext(PageContext)
  const [panels, setPanels] = useState([])
  const [load, setLoad] = useState(false)
  const tabs = [
    {
      tab: translate.vacancy[language],
    },
    {
      tab: translate.internship[language],
    },
  ]
  const linkBuilder = (url) => {
    if (!url) return ''
    if (url.startsWith('http://') || url.startsWith('https://')) return url
    return `${config.API_URL}${url.startsWith('/') ? '' : '/'}${url}`
  }
  useEffect(() => {
    (async () => {

    await setLoad(false)
    const { data } = await CareersAPI.getAll()
    await setPanels([[...data.vacancy], [...data.program]])
    await setLoad(true)
  
    })();
  }, [])
  return load ? (
    <section className={className}>
      <PageHeader
        link={'#'}
        crumb={translate.careers[language]}
        title={translate.careers[language]}
      />
      <div className={styles.container}>
        <Tabs className="careers-tabs">
          <TabList>
            {tabs.map((item, i) => (
              <Tab key={i}>{item.tab}</Tab>
            ))}
          </TabList>

          {panels.map((panel, i) => (
            <TabPanel key={i}>
              {panel.map((item, i) => (
                <VacancyCard
                  key={i}
                  img={linkBuilder(item.photoLocation)}
                  title={item.title?.[language] || item.title?.TR || item.title?.AZ || ''}
                  text={
                    language === 'RU'
                      ? item.description_ru || item.description_az
                      : language === 'TR'
                      ? item.description_tr || item.description_az
                      : language === 'EN' || language === 'ENG'
                      ? item.description_en || item.description_eng || item.description_az
                      : item.description_az
                  }
                  date={new Date(item.date).toLocaleDateString()}
                  place={item.location?.[language] || item.location?.TR || item.location?.AZ || ''}
                  link={`/vacancy/${item._id}`}
                />
              ))}
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Careers
